export interface IFrameMessagePayload {
    url: string;
    message: string;
}
